import {Button, Input, Label } from 'reactstrap';
import React, { Component } from 'react';

const VendorsTable = (props) => {

    function renderRows(){
        return props.vendors.map(vendor => 
        <tr key={vendor.id}>
            <td>{vendor.code}</td>
            <td>{vendor.name}</td>
            <td><Button color="link" onClick={evt => props.onVendorUpdate(vendor)}>עריכה</Button><Button color="link" onClick={evt => props.onVendorDelete(vendor)}>מחיקה</Button></td>
        </tr>);
    }

    return (
    <div>
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th>קוד ספק</th>
                    <th>שם ספק</th>
                    <th>פעולות</th>
                </tr>
            </thead>
            <tbody>
                {renderRows()}
            </tbody>
        </table>
    </div>
    );
  };
  
  export default VendorsTable;
  